import {Component, Inject} from 'ng-metadata/core';
import {UserAreaService} from './userArea.service';
import {UserSessionManagerService} from  '../../../security/userSessionManager.service';
import {getAttributesMap, getVid, getBackendSystem} from '../../../appConfig/appConfigForward';
import {PrimolyticsService, beacon} from '../../../analytics/primolytics.service';
import {MobileMenu} from '../menu.service';
import {JwtUtilService} from '../../../security/jwtUtil.service';
import {PrimoExploreService} from '../../../primoExplore/primoExplore.service';
import {LoginIframeService} from '../../../primoExplore/loginIframe.service';
import {MediaQueries} from "../../../infra/mediaQueries.service";
import {isBrowserSafari} from '../../../infra/browserSniffer';
import { FavoritesWarningMessageService } from '../../../favorites/favoritesWarningMessage/favoritesWarningMessage.service';

@Component({
    selector: "prm-user-area",
    templateUrl: 'components/search/topbar/userArea/user-area.html'
})


export class PrmUserArea {
    private showMoreOptions: boolean;
    private showUserMenu: boolean;
    private attributesMap = getAttributesMap();
    private jwt: Object;
    private view = getVid();
    languages: string[];
    displayLanguage: boolean;
    private _selectedLanguage: string;
    private menuTimeout;
    private showUserArea: boolean = true;
    private isOpen: boolean = false;
    private spinnerTimedOut: boolean = false;
    private displayedGuest: string;
    private isRoleShow: boolean = false;
    private isBlocked: string;

    private KEY_CODE = {
        COMMA: 188,
        SEMICOLON: 186,
        ENTER: 13,
        ESCAPE: 27,
        SPACE: 32,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        END: 35,
        HOME: 36,
        LEFT_ARROW: 37,
        UP_ARROW: 38,
        RIGHT_ARROW: 39,
        DOWN_ARROW: 40,
        TAB: 9,
        BACKSPACE: 8,
        DELETE: 46
    };

    constructor(private userAreaService: UserAreaService,
                @Inject('topBarIcons') private topBarIcons,
                private mobileMenu: MobileMenu,
                private userSessionManagerService: UserSessionManagerService,
                private jwtUtilService: JwtUtilService,
                private favoritesWarningMessageService: FavoritesWarningMessageService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('$http') private $http: ng.IHttpService,
                @Inject('$state') private $state: ng.ui.IStateService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$mdDialog') private $mdDialog: ng.material.IDialogService,
                @Inject('$element') private $element,
                @Inject('$scope') private $scope: ng.IScope,
                private primoExploreService: PrimoExploreService,
                private primolyticsService: PrimolyticsService,
                private loginIframeService: LoginIframeService,
                private mediaQueries: MediaQueries) {
        this._selectedLanguage = this.$translate.use();
        this.languages = this.attributesMap.interfaceLanguageOptions.split(",");
        this.displayLanguage = this.displayLanguageIfThereIsMoreThanOne(this.languages.length);
        this.showMoreOptions = false;
        this.showUserMenu = false;
        let menuTimeout = this.menuTimeout;
        let menuHoverDelay = 400;
        this.$timeout(()=> {
            this.spinnerTimedOut = true;
        }, 4000);

        if (this.$state.current.name === 'deposit'||this.$state.current.name === 'delivery' || this.$state.current.name === 'canonDelivery' || this.$state.current.name === 'cnameDelivery') {
            this.showUserArea = false;
        }

        this.$translate('eshelf.user.anonymous')
            .then((translation) =>
                this.displayedGuest = translation
            );

        this.$element[0].querySelectorAll('button')[1].setAttribute('id', 'changUserStatus');
    }

    ngOnInit() {
        this.$scope.$watch(()=>this.showUserMenu, (newVal, oldVal)=> {
            this.$timeout(() => {
                this.unfocusActionButtons('md-fab-actions button');
                this.unfocusActionButtons('md-fab-actions md-select');
            }, 400);
        });
    }

    ngAfterViewInit(){
        this.$timeout(()=> {
            this.isBlocked = 'block';
        }, 3000);
    }

    //this function places tabindex=-1 on all fab-action buttons so that they aren't focused when md-fab-speed-dial is closed
    private unfocusActionButtons(str) {
        let actionButtons: [Element] = this.$element[0].querySelectorAll(str);
        if (!this.showUserMenu && this.$element) {
            for (let button of actionButtons) {
                button.setAttribute('tabindex', '-1');
            }
        }
        else {
            for (let button of actionButtons) {
                button.setAttribute('tabindex', '0');
            }
        }
    }

    private changUserStatus() {
        this.showUserMenu = !this.showUserMenu;

        if (!isBrowserSafari()) {
            this.$timeout(()=> {
                let element = document.querySelector('prm-authentication button');
                element.focus();

            }, 100);
        }
    }


    private enableMobileMenu() {
        this.favoritesWarningMessageService.hideFavoritesWarningForGuestsByMenu();
        this.mobileMenu.setMobileMenu(true);
        this.mobileMenu.setLinksMenuVisible(true);
        if (!this.showUserArea) {
            this.mobileMenu.setDepositDisplay(true);
        }
        this.showMainMenu();
    }

    public showMainMenu() {
        let mainMenuTemplate = '' +
            '<md-dialog aria-label="Main menu" ' +
            'class="light-on-dark-dialog full-cover-dialog"> ' +
            '<md-dialog-content class="layout-full-height"> ' +
            '<prm-main-menu menu-type="full"></prm-main-menu> ' +
            '</md-dialog-content>' +
            '</md-dialog>';

        this.addBackgroundDarkClass();

        this.$mdDialog.show({
            bindToController: true,
            controller: function () {
            },
            controllerAs: 'ctrl',
            template: mainMenuTemplate,
        });
    }

    public addBackgroundDarkClass() {
        this.primoExploreService.dimScreen(true);
    }

    get selectedLanguage() {
        return this.$translate.use();
    }

    set selectedLanguage(selectedLang) {
        this._selectedLanguage = selectedLang;
    }

    get displayedUser() {
        if (this.userName()) {
            return this.userName();
        }

        return this.displayedGuest;

    }

    private displayLanguageIfThereIsMoreThanOne(numLang) {
        if (numLang === 1) {
            return false;
        }
        return true;
    }

    userName() {
        if (getBackendSystem() === 'suprima') {
            return this.userSessionManagerService.getUserNameForDisplay();
        } else {
            return this.userSessionManagerService.getUserName();
        }
    }

    private showSpinner() {
        if (this.spinnerTimedOut || this.jwtUtilService.backFromLoginIframe) {
            return false;
        }
        if (this.loginIframeService.iframeSilentLoginEnabled && !this.jwtUtilService.backFromLoginIframe) {
            return true;
        }
        return false;
    }

    public detectMobile() {
        if (this.mediaQueries.xs || this.mediaQueries.sm) {
            return true;
        }
        return false;
    }

    private closeLinksMenu() {
        this.mobileMenu.setLinksMenuVisible(false);
        this.$mdDialog.hide();
    }

    // @HostListener('keydown', ['$event'])
    private keydownSupport(e) {
        let keyCodes = this.KEY_CODE;

        if (e.keyCode === 27) {
            e.preventDefault();
            this.closeLinksMenu();
            return document.querySelector('#changUserStatus').focus();
        }

    }

    /*Accessibility message that the user was successfully Signed in/Signed out*/
    public getRoleAlertMessage() {
        if (!this.$translate.isReady()){
            return undefined;
        }

        const msg =  this.jwtUtilService.isGuest()
            ? this.$translate.instant('nui.aria.signOutSuccess')
            : this.$translate.instant('nui.aria.signInSuccess');

        return msg;
    }

    get signInOrOutTooltipLabel(){
        if (!this.$translate.isReady()){
            return undefined;
        }
        return this.$translate.instant(this.userName().length==0 ?  'nui.clisckSignIn.tooltip'  : 'nui.clisckSignOut.tooltip')
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/topbar/userArea/userArea.directive.ts